import { DOCUMENT } from "@angular/common";
import { Component, HostListener, Inject, Input, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, debounceTime, takeUntil } from "rxjs";
import { DataService } from "src/app/shared/services/data.service";
import { RouterService } from "src/app/shared/services/router.service";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-events-lobby-page',
  templateUrl: './events-lobby-page.component.html',
  styleUrls: ['./events-lobby-page.component.scss', './events-lobby-page.component.en.scss'],
})
export class EventsLobbyComponent implements OnInit, OnDestroy {
  @Input() pageUrl: string | null = null;

  pageData: any;
  currentPage: number = 1;

  paginatorContainerCssClass = 'pagination';
  rangeSize: number = 3;

  isMobile: boolean = false;
  isLoading: boolean = false;
  showFiltersMobileModal: boolean = false;

  searchTerm: string = '';
  searchTermObj = new Subject<string>();
  searchRequest: any = {
    fromDate: null,
    toDate: null,
    eventTypes: [],
    campuses: [],
    interest: [],
    isFree: false,
    isOnline: false
  };


  private ngUnsubscribeUrlListener: Subject<void> = new Subject<void>();

  constructor(
    private dataService: DataService,
    private routerService: RouterService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    private router: Router
  ) {

    this.isMobile = window.innerWidth <= 767;
    this.rangeSize = this.isMobile ? 1 : 3;
    if (this.isMobile) {
      this.paginatorContainerCssClass = 'pagination mobile';
    }

    this.searchTermObj.pipe(debounceTime(1000)).subscribe((term) => {
      this.searchTerm = term;
      this.searchEventsData();
    });
  }

  ngOnInit(): void {
    this.changeAddithinalStyles();
    this.handelUrlParameters();
    this.getIndexData();
  }

  ngOnDestroy(): void {
    this.changeAddithinalStyles(true);
    this.ngUnsubscribeUrlListener.next();
    this.ngUnsubscribeUrlListener.complete();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    let width = (event.target as Window).innerWidth;
    this.isMobile = width <= 767; //1300
  }

  private changeAddithinalStyles(destroy: boolean = false) {
    let element = this.document.querySelector('.page-content');
    if (element) {
      if (destroy) {
        this.renderer.removeStyle(element, 'padding');
      } else {
        this.renderer.setStyle(element, 'padding', 'inherit');
      }
    }

    element = this.document.querySelector(
      '.page-content app-standard-content-page app-card-header'
    );
    if (element) {
      if (destroy) {
        this.renderer.removeStyle(element, 'display');
      } else {
        this.renderer.setStyle(element, 'display', 'none');
      }
    }

    element = this.document.querySelector('.portal-body .page-content-wrap');
    if (element) {
      if (destroy) {
        this.renderer.removeStyle(element, 'background-color');
      } else {
        this.renderer.setStyle(element, 'background-color', 'white');
      }
    }
  }

  getIndexData() {
    this.isLoading = true;
    let url = environment.apiUrl + '/Portal/Events-Api/Index';
    let request: any = {
      pageUrl: this.pageUrl ?? this.routerService.getCurrentComponentRoute(),
      cultureCode: this.dataService.getCultureCode(),
      currentPage: this.currentPage,
      searchTerm: this.searchTerm,
      fromDate: this.searchRequest.fromDate,
      toDate: this.searchRequest.toDate,
      eventTypes: this.searchRequest.eventTypes,
      campuses: this.searchRequest.campuses,
      interests: this.searchRequest.interest,
      isFree: this.searchRequest.isFree,
      isOnline: this.searchRequest.isOnline
    };

    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.pageData = responseData;
        this.isLoading = false;
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  searchEventsData(pageMove: boolean = false) {
    if (!pageMove) {
      this.currentPage = 1;
    }
    let url = environment.apiUrl + '/Portal/Events-Api/SearchEvents';
    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
      currentPage: this.currentPage,
      eventsPerPage: this.pageData.eventsPerPage,
      searchTerm: this.searchTerm,
      fromDate: this.searchRequest.fromDate,
      toDate: this.searchRequest.toDate,
      eventTypes: this.searchRequest.eventTypes,
      campuses: this.searchRequest.campuses,
      interests: this.searchRequest.interest,
      isFree: this.searchRequest.isFree,
      isOnline: this.searchRequest.isOnline
    };

    this.updateUrlParameters();
    this.isLoading = true;
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.pageData.eventsLobbyData = responseData;
        this.isLoading = false;
      },
      error: (e) => {
        console.error(e);
        this.isLoading = false;
      },
    });
  }

  goToPage(pageNumber: number) {
    if (event) event.preventDefault();
    if (
      this.pageData.eventsLobbyData.eventsList != undefined &&
      this.pageData.eventsLobbyData.eventsList.length &&
      pageNumber >= 1 &&
      pageNumber <=
        Math.ceil(
          this.pageData.eventsLobbyData.totalResults /
            this.pageData.eventsPerPage
        )
    ) {
      this.currentPage = pageNumber;
      this.searchEventsData(true);
    }
  }
  
  onInputChange(event: any) {
    this.searchTermObj.next(event.target.value);
  }

  changeDateFrom(event: Date) {
    this.searchRequest.fromDate = this.toISOStringLocal(event);
    this.searchEventsData();
  }

  changeDateTo(event: Date) {
    this.searchRequest.toDate = this.toISOStringLocal(event);
    this.searchEventsData();
  }

  filtersChange(event: any, type: number) {
    switch (type) {
      case 1:
        this.searchRequest.interest = event;
        break;
      case 2:
        this.searchRequest.eventTypes = event;
        break;
      case 3:
        this.searchRequest.campuses = event;
        break;
    }
    this.searchEventsData();
  }

  checkboxChange() {
    this.searchEventsData();
  }

  checkIfShowEventsList(): boolean {
    return this.pageData 
      &&this.pageData.eventsLobbyData 
      && this.pageData.eventsLobbyData.eventsList 
      && this.pageData.eventsLobbyData.eventsList.length;
  }

  private toISOStringLocal(date: Date): string {
    function pad(number: number) {
        if (number < 10) {
            return '0' + number;
        }
        return number;
    }

    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) +
        '.' + (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
  }

  clearSearch($event: any) {
    $event.preventDefault();

    this.searchTerm = '';
    this.searchRequest = {
      fromDate: null,
      toDate: null,
      eventTypes: [],
      campuses: [],
      interest: [],
      isFree: false,
      isOnline: false
    };
    
    this.searchEventsData();
  }

  openFiltersMobilePopup() {
    this.showFiltersMobileModal = true;
    this.changeSidebarMenu(false);
  }

  closeFiltersMobilePopup() {
    this.showFiltersMobileModal = false;
    this.changeSidebarMenu(true);
  }

  changeSidebarMenu(show: boolean) {
    let element = this.document.querySelector('app-sidebar');
    if(!element) return;
    if(show) {
      this.renderer.removeStyle(element, 'display');
    } else {
      this.renderer.setStyle(element, 'display', 'none');
    }
  }

  filtersChangeMobile(filter: any, type: number) {
    let index = -1;
    switch (type) {
      case 1:
        index = this.pageData.eventsLobbyData.interests.findIndex((f: any) => f.id == filter.id);
        if(index != -1) {
          this.pageData.eventsLobbyData.interests[index].selected = filter.checked;
          let selectedIndex = this.searchRequest.interest.indexOf(filter.id);

          if(selectedIndex == -1 && filter.checked) {
            this.searchRequest.interest.push(filter.id);
          } else {
            if(!filter.checked) {
              this.searchRequest.interest.splice(selectedIndex, 1);
            }
          }
        }
        break;
      case 2:
        index = this.pageData.eventsLobbyData.eventsTypes.findIndex((f: any) => f.id == filter.id);
        if(index != -1) {
          this.pageData.eventsLobbyData.eventsTypes[index].selected = filter.checked;
          let selectedIndex = this.searchRequest.eventTypes.indexOf(filter.id);

          if(selectedIndex == -1 && filter.checked) {
            this.searchRequest.eventTypes.push(filter.id);
          } else {
            if(!filter.checked) {
              this.searchRequest.eventTypes.splice(selectedIndex, 1);
            }
          }

        }
        break;
      case 3:
        index = this.pageData.eventsLobbyData.campuses.findIndex((f: any) => f.id == filter.id);
        if(index != -1) {
          this.pageData.eventsLobbyData.campuses[index].selected = filter.checked;
          let selectedIndex = this.searchRequest.campuses.indexOf(filter.id);

          if(selectedIndex == -1 && filter.checked) {
            this.searchRequest.campuses.push(filter.id);
          } else {
            if(!filter.checked) {
              this.searchRequest.campuses.splice(selectedIndex, 1);
            }
          }
        }
        break;
    }

    this.searchEventsData();
  }

  private handelUrlParameters() {
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribeUrlListener)).subscribe({
      next: (params) => {
        this.searchTerm = params['term'] ?? '';
        this.searchRequest.fromDate = params['fromDate'] ? this.parseDate(params['fromDate']) : null;
        this.searchRequest.toDate = params['toDate'] ? this.parseDate(params['toDate']) : null;
        this.searchRequest.eventTypes = params['eventTypes'] ? params['eventTypes'].split(',') : [];
        this.searchRequest.campuses = params['campuses'] ? params['campuses'].split(',') : [];
        this.searchRequest.interest = params['interest'] ? params['interest'].split(',') : [];
        this.searchRequest.isFree = params['isFree'] == 'true';
        this.searchRequest.isOnline = params['isOnline'] == 'true';

        let page = params['page'];
        let validPage = page && parseInt(page) >= 1;
        this.currentPage = validPage ? parseInt(page) : 1;

        //set defult fromDate value
        if(!this.searchRequest.fromDate) {
          this.searchRequest.fromDate = new Date();
          this.updateUrlParameters();
        }
      },
      error: (e) => console.error('Error while fetching query params', e),
    });
  }

  private updateUrlParameters() {
    let queryParams: any = {};
    if (this.currentPage > 1)
      queryParams.page = this.currentPage;

    if (this.searchTerm != undefined && this.searchTerm !== '')
      queryParams.term = this.searchTerm;

    if (this.searchRequest.fromDate) {
      queryParams.fromDate = this.formatDate(this.searchRequest.fromDate);
    }

    if (this.searchRequest.toDate) {
      queryParams.toDate = this.formatDate(this.searchRequest.toDate);
    }

    if (this.searchRequest.eventTypes.length > 0) {
      queryParams.eventTypes = this.searchRequest.eventTypes.join(',');
    }

    if (this.searchRequest.campuses.length > 0) {
      queryParams.campuses = this.searchRequest.campuses.join(',');
    }

    if (this.searchRequest.interest.length > 0) {
      queryParams.interest = this.searchRequest.interest.join(',');
    }

    if (this.searchRequest.isFree) {
      queryParams.isFree = this.searchRequest.isFree;
    }

    if (this.searchRequest.isOnline) {
      queryParams.isOnline = this.searchRequest.isOnline;
    }

    queryParams = Object.keys(queryParams).length > 0 ? queryParams : null;

    var url = this.router.createUrlTree([], {
        relativeTo: this.route,
        queryParams: queryParams,
      })
      .toString();

    window.history.pushState({ path: url }, '', url);
  }

  private formatDate(dateString: string): string {
    let date = new Date(dateString);
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }

  private parseDate(dateString: string): Date {
    let parts = dateString.split('.');
    let year = parseInt(parts[2], 10);
    let month = parseInt(parts[1], 10) - 1;
    let day = parseInt(parts[0], 10);
    return new Date(Date.UTC(year, month, day));
  }
}